module.exports = __webpack_public_path__ + "static/media/s2-dolce.a56021c8.png";